import { render, staticRenderFns } from "./message-toolbar.vue?vue&type=template&id=e6b9b1a2&"
import script from "./message-toolbar.vue?vue&type=script&lang=js&"
export * from "./message-toolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports